package acupoint.containers

import com.jingfangpai.api.clients.AcupointApiClient
import react.*
import react.dom.div
import setTitle
import acupoint.components.AcupointList

external interface AcupointListPageProps : RProps {

}

data class AcupointListPageContextData(var getAcupointList: (okCallback: (result: com.jingfangpai.common.data.response.ApiResponse<List<com.jingfangpai.common.orm.mapping.Acupoint>>) -> Unit, errorCallback: (Throwable) -> Unit) -> Unit)

val AcupointListPageContext = createContext(AcupointListPageContextData({ okCallback, errorCallback -> }))

val AcupointListPageProvider = functionalComponent<AcupointListPageProps> { props ->

    setTitle("穴位")

    useEffectOnce {
        console.log("acupoint list page")
    }

    AcupointListPageContext.Provider(AcupointListPageContextData(AcupointApiClient::getList)) {
        div("AcupointListPage-page") {
           child(AcupointList)
        }
    }
}
